module.exports = require('./helpers/bundle-url').getBundleURL('kuLgW') + "football_pen_miss.c1eb9941.png";